import groq from "groq"

export const articleGroupProjection = () => groq`
    "id": _id,
    key,
    name
`
